module.exports = __webpack_public_path__ + "static/0028-41afac46e41e2dc2428e1ea81c200083.png";